import { ChangeDetectionStrategy, Component, signal } from "@angular/core";

import { FeatureFlagEnum, RouteEnum } from "src/app/shared/enums";

import { ISettingGroup } from "@shared/interfaces";
import { FeatureFlagService } from "@shared/services";

@Component({
  standalone: false,
  selector: "app-user-settings",
  templateUrl: "./user-settings.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSettingsComponent {
  public allSettingGroups = signal<ISettingGroup[]>([]);

  public readonly translations: any = {
    title: $localize`:@@shared.usersettings:User settings`,
  };

  constructor(private featureFlagService: FeatureFlagService) {
    this.setupSettings();
  }

  private setupSettings = (): void => {
    const isLanguagesEnabled = this.featureFlagService.isEnabled(FeatureFlagEnum.LANGUAGES);

    this.allSettingGroups.set([
      {
        settings: [
          {
            route: RouteEnum.USER_SETTINGS_PROFILE,
            icon: "assignment_ind",
            title: $localize`:@@shared.profile:Profile`,
            description: $localize`:@@user-settings.userprofilesettings:User profile settings`,
            isHidden: !isLanguagesEnabled,
          },
          {
            route: RouteEnum.USER_SETTINGS_MEMBERSHIPS,
            icon: "group",
            title: $localize`:@@shared.memberships:Memberships`,
            description: $localize`:@@action.user-settings.manageorgmemberships:Manage your org memberships`,
          },
          {
            route: RouteEnum.USER_SETTINGS_API_KEYS,
            icon: "key",
            title: $localize`:@@shared.apikeys:API keys`,
            description: $localize`:@@action.user-settings.manageyourapikeys:Manage your API keys`,
          },
        ],
      },
    ]);
  };
}
